export default __webpack_public_path__ + "static/media/brakekit-small-lime.2f63ff5e.webp";